<div class="dm-hidden-placeholder"></div>
<ui-view name="summary" [hidden]="!uiRouter.stateService.includes(routeName.InternalEngagementSummary)"></ui-view>
<ui-view name="financials" [hidden]="!uiRouter.stateService.includes(routeName.InternalEngagementFinancials)"></ui-view>
<ui-view name="staffing" [hidden]="!uiRouter.stateService.includes(routeName.InternalEngagementStaffing)"></ui-view>